import { Tabs } from "antd";
import React, { FC, useEffect, useState } from "react";
import { generatePath, useHistory } from "react-router";
import { SubjectModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { ExamSubjectModel } from "../../../models/ExamModels/exam.model";
import { STUDENT_ANALYTICS_CHAPTERS_LIST } from "../../../routes/routeConstants/appRoutes";
import SubjectService from "../../../services/CourseServices/SubjectService/subject.service";
import { ExamSubjectsService } from "../../../services/ExamService/SubjectService/subject.service";
import AppHeader from "../../../shared/components/AppHeader";
import { SwitchTabs } from "../../../shared/components/SwitchTabs";
import ListPaperAnalytics from "./ListAnalyticsPaperCards";
import ListAnalyticsSubjectCards from "./ListAnalyticsSubjectCards";
// import AnalyticsCard from '../../../shared/components/AnalyticsComponents/AnalyticsCard';
import Filters from "../../../shared/components/Filters";

const { TabPane } = Tabs;
const StudentAnalytics: FC = () => {
  const history = useHistory()
  const [schoolSubjects, setSchoolSubjects] = useState<SubjectModel[]>([]);
  const [examSubjects, setExanSubjects] = useState<ExamSubjectModel[]>([]);
  const [selectedSubjects, setSelectedSubjects] = useState(0);
  const fetchSchoolSubjects = () => {
    let queryParams = `?page=${1}&class_room_id=${30}&search=${''}`

    SubjectService.getClassroomSubjectsList(queryParams,
        (subjects:any,pageMeta:any)=>{
            setSchoolSubjects([...subjects])
        },
        ()=>{},
        ()=>{},
    ).then()
    
  };

  const fetchExamSubjects = () => {
    
  };
  useEffect(() => {
    fetchSchoolSubjects();
  }, []);

  return (
    <div className="page-view">
      <AppHeader
        headerText="Analytics"
        showSearch={true}
        showButton={false}
        showBreadCrumb={false}
        showFilter={false}
        buttonIcon={null}
      />
      <Tabs
        defaultActiveKey="1"
        onChange={() => {}}
        className="analytics__tabs"
      >
        <TabPane tab="Subject" key="1">
          <SwitchTabs
            tabs={["School", "Exam"]}
            defaultSelected={0}
            onSelect={(value) => {
              if(!value) {
                schoolSubjects.length == 0 && fetchSchoolSubjects()
              } else {
                schoolSubjects.length == 0 && fetchSchoolSubjects()
              }
              setSelectedSubjects(value);
            }}
          />
          {selectedSubjects ? (
            <>
            {/* <AnalyticsCard/> */}
            <ListAnalyticsSubjectCards
              showProgress
              subjects={schoolSubjects}
              onClick={(id, name) => {
                history.push({
                  pathname: generatePath(STUDENT_ANALYTICS_CHAPTERS_LIST, {studentId: 1, subjectId: id}),
                  state: {
                    subjectId: id,
                    subjectName: name
                  }
                  })
              }}
            />
            </>
          ) : (
            <>
            {/* <AnalyticsCard/> */}
            <ListAnalyticsSubjectCards
              showProgress
              subjects={schoolSubjects}
              onClick={(id, name) => {
                history.push({
                  pathname: generatePath(STUDENT_ANALYTICS_CHAPTERS_LIST, {studentId: 1, subjectId: id}),
                  state: {
                    subjectId: id,
                    subjectName: name
                  }
                  })
              }}
            />
            </>

          )}
        </TabPane>
        <TabPane tab="Schedule" key="3">
          Schedule
        </TabPane>
        <TabPane tab="Previous paper" key="4">
          <ListPaperAnalytics/>
        </TabPane>
      </Tabs>
    </div>
  );
};
export default StudentAnalytics;
